import React from "react";

import { useTranslation } from "react-i18next";
import useReactRouter from "use-react-router";
import Questions from "~/components/FAQ/Questions";
import { ITopic } from "~/components/FAQ/types";

import { shopConfig } from "~/helpers/shopConfig";

interface IParams {
  question?: string;
}

export const GiftCardFAQs = () => {
  const {
    match: {
      params: { question = "" }
    },
    history
  } = useReactRouter<IParams>();

  const { t } = useTranslation("faq");

  const topics: ITopic[] = t("topics", {
    returnObjects: true,
    ...shopConfig
  });

  if (!topics) {
    return null;
  }

  const topic = "giftcard";

  const currentTopic = topics.find(({ key }) => key === topic);

  const handleQuestionChange = (key: string) => {
    history.push(key ? `/${topic}/${key}` : `/${topic}`);
  };

  return (
    <React.Fragment>
      {currentTopic && (
        <Questions
          openQuestionKey={question}
          questions={currentTopic.questions}
          onQuestionChange={handleQuestionChange}
        />
      )}
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/GiftCard/GiftCardFAQs.tsx